module.exports = __webpack_public_path__ + "static/media/client_default.26d78c87.png";